/**
 * Fonte única da base URL da API. Escolhe o endpoint pela versão da API
 * (1 = legado, 2 = Laravel) e pela rota de acesso da sessão (intranet × Netskope).
 */
import { isNetskopeAccess } from '../lib/accessRoute';

const LARAVEL_API_VERSION = 2;
const DEFAULT_PROTOCOL = 'https://';

function withProtocol(endpoint) {
  if (/^https?:\/\//i.test(endpoint)) return endpoint;
  return (process.env.VUE_APP_HTTP || DEFAULT_PROTOCOL) + endpoint;
}

function intranetEndpoint(apiVersion) {
  return apiVersion === LARAVEL_API_VERSION
    ? process.env.VUE_APP_ENDPOINT_LARAVEL
    : process.env.VUE_APP_ENDPOINT;
}

function netskopeEndpoint(apiVersion) {
  return apiVersion === LARAVEL_API_VERSION
    ? process.env.VUE_APP_NETSKOPE_ENDPOINT_LARAVEL
    : process.env.VUE_APP_NETSKOPE_ENDPOINT;
}

export function resolveApiBase(apiVersion) {
  if (process.env.VUE_APP_ENV === 'dsv') {
    return process.env.VUE_APP_ENDPOINT;
  }

  const endpoint = isNetskopeAccess()
    ? netskopeEndpoint(apiVersion) || intranetEndpoint(apiVersion)
    : intranetEndpoint(apiVersion);

  return withProtocol(endpoint);
}
